import { useIntl } from '@capsicum/common';
import { useRouter } from '@capsicum/common-web';
import {
	CURRENCY_LABELS,
	CURRENCY_SHORTCODES,
	CurrencyType,
	useReceiveDetails
} from '@capsicum/features/wallet/shared';

import { CurrencyActionCard } from '../../ui';
import { S } from '../styles';

export const Receive = () => {
	const { $t } = useIntl();
	const { push } = useRouter();

	const receiveTexts = {
		amountFTText: $t('wallet.receive.sociosTokens'),
		chilizText: $t('wallet.receive.chilizText'),
		fanTokenText: $t('wallet.receive.fantokensText'),
		logosText: $t('wallet.receive.logos'),
		title: $t('wallet.receive.title')
	};

	const { data, isLoading } = useReceiveDetails();

	const chilizInfo = {
		amount: `${data?.remainingAmountBeforeLimit?.formattedMaxAmount} ${CURRENCY_SHORTCODES[CurrencyType.CHILIZ]}`,
		subTitle: receiveTexts.chilizText,
		title: CURRENCY_LABELS[CurrencyType.CHILIZ]
	};
	const fanTokenInfo = {
		amount: receiveTexts.amountFTText,
		logoLabel: receiveTexts.logosText,
		subTitle: receiveTexts.fanTokenText,
		title: CURRENCY_LABELS[CurrencyType.FANTOKENS]
	};

	return (
		<S.Container>
			<S.Title>{receiveTexts.title}</S.Title>

			<CurrencyActionCard
				currency={CurrencyType.CHILIZ}
				isLoading={isLoading}
				testID="receive-chiliz-card"
				texts={chilizInfo}
				onClick={() => push(`/wallet/receive/${CurrencyType.CHILIZ}`)}
			/>
			<CurrencyActionCard
				currency={CurrencyType.FANTOKENS}
				isLoading={isLoading}
				showStaticLogos
				testID="receive-fanToken-card"
				texts={fanTokenInfo}
				onClick={() => push(`/wallet/receive/${CurrencyType.FANTOKENS.toLowerCase()}`)}
			/>
		</S.Container>
	);
};
